<template>
  <div
    class="relative w-full min-h-12 min-w-20"
    style="padding-top: 56.25%"
    v-tippy="{
      content: tooltipText,
      theme: 'light-border',
      maxWidth: 250,
    }"
  >
    <div
      class="
        absolute
        outline-white
        rounded
        top-0
        left-0
        w-full
        h-full
        cursor-pointer
        flex flex-col
        items-center
        text-xxs
        xl:text-sm
        lg:gap-y-2
      "
      :class="isBigTile ? 'justify-center' : 'justify-between'"
    >
      <span
        class="flex w-full h-8 pl-1 pt-2 items-center"
        :class="isBigTile ? 'justify-center' : 'justify-between'"
      >
        <PlusIcon class="h-7 w-17 xl:h-8 xl:w-8 text-black rounded-full bg-white p-2" />
        <ViceDermatoscope class="h-12 w-12 xl:h-14 xl:w-14" v-if="icon === 'Dermatoscope'" />
        <ViceOtoscope class="h-12 w-12 xl:h-16 xl:w-16" v-if="icon === 'Otoscope'" />
        <ViceStethoscope class="h-12 w-12 xl:h-16 xl:w-16" v-if="icon === 'Stethoscope'" />
        <ViceGlasses class="h-12 w-12 xl:h-16 xl:w-16" v-if="icon === 'Glasses'" />
        <ViceScreenshare class="h-12 w-12 xl:h-16 xl:w-16" v-if="icon === 'Screen'" />
        <ViceMonitor class="h-12 w-12 xl:h-16 xl:w-16" v-if="icon === 'Monitor'" />
        <ViceCameraIcon class="h-12 w-12 xl:h-16 xl:w-16" v-if="icon === 'Camera'" />
      </span>
      <span>
        <span class="hidden xl:block">Add</span>
        {{ label }}
      </span>
    </div>
  </div>
</template>

<script>
import { directive } from 'vue-tippy';
import * as icons from '@heroicons/vue/solid';
import ViceCameraIcon from '../Icons/ViceCamera.vue';
import ViceDermatoscope from '../Icons/ViceDermatoscope.vue';
import ViceOtoscope from '../Icons/ViceOtoscope.vue';
import ViceStethoscope from '../Icons/ViceStethoscope.vue';
import ViceGlasses from '../Icons/ViceGlasses.vue';
import ViceScreenshare from '../Icons/ViceScreenshare.vue';
import ViceMonitor from '../Icons/ViceMonitor.vue';

export default {
  name: 'AddDeviceButton',
  directives: {
    tippy: directive,
  },
  components: {
    ...icons,
    ViceCameraIcon,
    ViceStethoscope,
    ViceDermatoscope,
    ViceOtoscope,
    ViceGlasses,
    ViceScreenshare,
    ViceMonitor,
  },
  props: {
    icon: { type: String, default: '' },
    label: { type: String, default: '' },
    tooltipText: { type: String, default: '' },
    isBigTile: { type: Boolean, default: false },
  },
  computed: {},
};
</script>
